import actionTypes from 'constants/actionTypes'


export const statusChange = () => {
  return {
    type: actionTypes.CONNECTION.STATUS_CHANGE
  }
}

export const socketConnected = () => {
  return {
    type: actionTypes.CONNECTION.SOCKET.CONNECTED
  }
}

export const socketConnecting = () => {
  return {
    type: actionTypes.CONNECTION.SOCKET.CONNECTING
  }
}

export const socketDisconnected = () => {
  return {
    type: actionTypes.CONNECTION.SOCKET.DISCONNECTED
  }
}
